import { animate, AnimationTriggerMetadata, style, transition, trigger } from '@angular/animations';

export const mobileSelectionAnimation: AnimationTriggerMetadata = trigger('mobileSelectionAnimation', [
  transition(':enter', [style({ opacity: 0 }), animate('100ms', style({ opacity: 1 }))]),
  transition(':leave', [animate('100ms', style({ opacity: 0 }))]),
]);
